import Vue from 'vue'
import install from './install'

const eventBus = new Vue()
eventBus.install = install

export default eventBus
